import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {Anchor, Icon, Text, StatusText} from '@albert-io/atomic';
import {renderTimeFromNow} from 'lib/timeUtils';
import './author-dashboard-activity.scss';

const BoldedText = ({children}) => {
  return <StatusText color='black'>{children}</StatusText>;
};

const AuthorPublishedQuestionItem = ({publishedQuestion}) => {
  const questionUrl = {
    pathname: `queue/${publishedQuestion.setId}/${publishedQuestion.questionId}`
  };
  return (
    <div>
      <div className='author-feedback-item__wrapper'>
        <div className='author-feedback-item__header-container'>
          <Icon icon='stars' iconStyle='light' className='u-mar-r_2' />
          <div className='author-feedback-item__header'>
            <div>
              <div className='author-feedback-item__prompt u-mar-b_1'>
                <Anchor href={questionUrl.pathname} target='_blank'>
                  {publishedQuestion.title}
                </Anchor>
              </div>
              <Text emphasis='lowest' size='s' as='div'>
                {publishedQuestion.subject}
              </Text>
            </div>
            <Text emphasis='lowest' size='s' className='author-feedback-item__time-stamp' as='div'>
              {renderTimeFromNow(publishedQuestion.publishedAt)}
            </Text>
          </div>
        </div>
      </div>
      <Text emphasis='medium' size='m' as='div' className='u-mar-t_3 author-feedback-item__message'>
        Status changed to <BoldedText>Published</BoldedText>
      </Text>
    </div>
  );
};

AuthorPublishedQuestionItem.propTypes = {
  publishedQuestion: PropTypes.shape({
    questionId: PropTypes.string,
    setId: PropTypes.string,
    subject: PropTypes.string,
    time: PropTypes.instanceOf(moment),
    title: PropTypes.string,
    type: PropTypes.string,
    publishedAt: PropTypes.instanceOf(moment),
    publishedAtDisplay: PropTypes.string
  })
};

export default AuthorPublishedQuestionItem;
